import { useTranslation } from "react-i18next";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../../components/ui/dialog/dialog";
import { DocumentList, DocumentListProps } from "./document-list";
import { useCallback } from "react";

interface DocumentListDialogProps extends DocumentListProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function DocumentListDialog({
  open,
  onOpenChange,
  onSelect,
  onCancel,
  ...props
}: DocumentListDialogProps) {
  const { t } = useTranslation();

  const handleCancel = useCallback(() => {
    onOpenChange(false);
    onCancel?.();
  }, [onCancel, onOpenChange]);

  const handleSelect = useCallback(
    (value: string[]) => {
      onOpenChange(false);
      onSelect(value);
    },
    [onOpenChange, onSelect]
  );

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="max-w-[680px]  h-[60%] "
        crossClassName="text-black"
      >
        <DialogHeader className="bg-transparent text-black">
          <DialogTitle className="text-black">
            {t("documentSelector.dialog.title")}
          </DialogTitle>
        </DialogHeader>

        <DocumentList
          {...props}
          onCancel={handleCancel}
          onSelect={handleSelect}
        />
      </DialogContent>
    </Dialog>
  );
}
